<template>
  <div class="c-user-card">
    <div class="c-user-card__layout">
      <div class="c-user-card__avatar"></div>
      <div class="c-user-card__warp">
        <div class="c-user-card__warp__first__line">
          <div class="c-user-card__name">{{ staffName }}</div>
          <div>欢迎进入Linkkap系统</div>
        </div>
        <div v-show="staffPositionName || staffOrgName" class="c-user-card__warp__line">
          <div class="c-user-card__text">{{ staffPositionName || '-' }}</div>
          <div class="c-user-card__text c-user-card__text__org">{{ staffOrgName || '-' }}</div>
        </div>
        <div class="c-user-card__warp__line">
          <div class="c-user-card__text">{{ userAuthText }}</div>
          <div class="c-user-card__text">{{ staffPhone }}</div>
          <div class="c-user-card__text c-user-card__text__email">{{ staffEmail }}</div>
          <div class="c-user-card__icon" title="账号设置" @click="gotoSettingPage">
            <a-icon type="setting" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    goToPersonalCenter: {
      type: Function,
      default: null
    },
  },
  computed: {
    ...mapState('user-info', {
      userData: 'userInfo',
      staffInfo: 'staffInfo'
    }),
    userInfo() {
      return this.userData.user || {}
    },
    staffName() {
      return this.staffInfo.name || this.userInfo.name || '-'
    },
    staffPositionName() {
      return (this.staffInfo.position || {}).name
    },
    staffOrgName() {
      const path = [].concat(((this.staffInfo.position || {}).org || {}).path || [])
      path.reverse()
      return path.map(orgPath => orgPath.name).join('/') || ''
    },
    userAuthText() {
      return this.userInfo.realNameStatus === 0 ? '未实名' : (this.userInfo.realNameStatus !== 1 ? '未授权' : '已实名')
    },
    staffPhone() {
      return this.staffInfo.phone || this.userInfo.phone || '-'
    },
    staffEmail() {
      return this.staffInfo.email || '-'
    }
  },
  methods: {
    ...mapActions('user-info', [
      'getAppInfoByCode',
    ]),
    gotoSettingPage() {
      this.goToPersonalCenter('/personal-center/account-setting.html')
    },
  }
}
</script>

<style lang="scss">
.c-user-card {
  background: #fff;
  padding: 0 0.26rem;
  height: 2rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  .c-user-card__layout {
    display: flex;
    width: 100%;
    font-size: 0.14rem;
  }
  .c-user-card__avatar {
    position: relative;
    top: -0.2rem;
    min-width: 0.6rem;
    width: 0.6rem;
    height: 0.6rem;
    background: url(~@/assets/images/workbench/head.png) no-repeat;
    background-size: 100% 100%;
  }
  .c-user-card__warp {
    margin-left: 0.2rem;
    width: calc(100% - 0.8rem);
  }
  .c-user-card__warp__first__line, .c-user-card__warp__line {
    display: flex;
    align-items: center;
  }
  .c-user-card__warp__first__line {
    color: #333;
    margin-bottom: 0.04rem;
    .c-user-card__name {
      font-weight: bold;
      font-size: 16px;
      max-width: 160px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .c-user-card__name::after {
      content: "，";
    }
  }
  .c-user-card__warp__line {
    margin-top: 0.16rem;
    color: #7F7F7F;
    .c-user-card__text {
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 40px;
    }
    .c-user-card__text+.c-user-card__text {
      padding-left: 20px;
    }
    .c-user-card__text+.c-user-card__text::before {
      content: "";
      position: absolute;
      left: 10px;
      top: 20%;
      height: 60%;
      width: 1px;
      border-left: 1px solid #7F7F7F;
    }
    .c-user-card__text__org {
      flex: 1;
      min-width: 120px;
    }
    .c-user-card__text__email {
      max-width: 200px;
    }
    .c-user-card__icon {
      margin-left: 20px;
      font-size: 19px;
      cursor: pointer;
      color: rgba(24, 144, 255, 1);;
    }
  }
}
</style>
